import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_4_174)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.66705 -7.62939e-06C1.64117 -7.62939e-06 1.14441e-05 1.57291 1.14441e-05 3.51399V15.7367C1.14441e-05 17.0689 0.77295 18.2268 1.91273 18.8237V19.6581C1.91273 20.9521 3.00726 22 4.35785 22H5.207C6.55759 22 7.65212 20.9521 7.65212 19.6581V19.2507H15.3042V19.6581C15.3042 20.9521 16.3988 22 17.7481 22H18.5985C19.9491 22 21.0425 20.9521 21.0425 19.6581V18.1037C21.6368 17.4784 22 16.6484 22 15.7367V3.51399C22 1.57291 20.3576 -7.62939e-06 18.3329 -7.62939e-06H3.66705ZM4.62343 0.916073C2.59874 0.916073 0.956352 2.49007 0.956352 4.43006V10.2359C0.956352 12.177 2.59874 13.7499 4.62343 13.7499H17.3766C19.4013 13.7499 21.0436 12.177 21.0436 10.2359V4.43006C21.0436 2.49007 19.4013 0.916073 17.3766 0.916073H4.62343ZM5.7394 16.0417C5.7394 16.8009 5.09625 17.4164 4.30424 17.4164C3.51223 17.4164 2.86911 16.8009 2.86911 16.0417C2.86911 15.2825 3.51223 14.667 4.30424 14.667C5.09625 14.667 5.7394 15.2825 5.7394 16.0417ZM18.6521 17.4164C19.4441 17.4164 20.0861 16.8009 20.0861 16.0417C20.0861 15.2825 19.4441 14.667 18.6521 14.667C17.8589 14.667 17.217 15.2825 17.217 16.0417C17.217 16.8009 17.8589 17.4164 18.6521 17.4164Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4_174",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22,
				height: 22,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBus);
export { ForwardRef as ReactComponent };
